function ControlRegistrationParams(definition, group) {
    this.definition = definition;
    this.group = group;
}

module.exports = ControlRegistrationParams;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/control-registration-params.js
// module id = 1055
// module chunks = 0